import mutations from './medicalRecordSheet.mutations'
import actions from './medicalRecordSheet.actions'
import getters from './medicalRecordSheet.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
